import { Component, EventEmitter, Output } from '@angular/core';
import {
  GcButtonComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-mark-as-done-button',
  imports: [GcButtonComponent, IpoTranslatePipe],
  templateUrl: './mark-as-done-button.component.html',
  styleUrl: './mark-as-done-button.component.scss',
})
export class MarkAsDoneButtonComponent {
  @Output() markAsDone = new EventEmitter();
}
